import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lds-accordion',
  templateUrl: './accordion-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.display]': "'contents'",
  },
})
export class AccordionGroupComponent {}
